import React from "react";
import { Container, Box } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";

const Loader = () => (
  <Container
    maxWidth="sm"
    sx={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Box>
      <ThreeDots height="80" width="80" color="#00d4ff" />
    </Box>
  </Container>
);

export default Loader;
